export type ReviewRequestBlacklist = {
  id: string | number;
  email: string;
  reason: string;
  source_detail: string;
  created_at: Date;
  updated_at: Date;
};

export type CreateReviewRequestBlacklist = Pick<
  ReviewRequestBlacklist,
  "email" | "reason" | "source_detail"
>;

export const REASON_OPTIONS = [
  { value: "no_consent", label: "No Consent" },
  { value: "unsubscribed", label: "Unsubscribed" },
  { value: "inactive_recipient", label: "Inactive Recipient" },
  { value: "invalid_email", label: "Invalid Email" },
];

export const REASON_COLORS: Record<string, string> = {
  no_consent: "orange",
  unsubscribed: "red",
  inactive_recipient: "gray",
  invalid_email: "pink",
};

export const REASON_LABELS: Record<string, string> = {
  no_consent: "No Consent",
  unsubscribed: "Unsubscribed",
  inactive_recipient: "Inactive Recipient",
  invalid_email: "Invalid Email",
};

export const REASON_DESCRIPTIONS: Record<string, string> = {
  no_consent: "User never gave consent to receive review requests",
  unsubscribed: "User explicitly opted out of review requests",
  inactive_recipient: "Emails to this user are not being received",
  invalid_email: "The email address is invalid or does not exist",
};
